import React from "react";
import { motion } from "framer-motion";
import { Calendar, MapPin, Star } from "lucide-react";
import { useLanguage } from "../i18n";

export default function Events() {
  const { t } = useLanguage();
  const schedule = t("home.serviceSchedule", []);
  const events = t("home.events", []);

  return (
    <div className="font-sans-clean min-h-screen bg-[#FDF8F3]">
      <section className="relative py-20 sm:py-24 overflow-hidden bg-[#5b2229]">
        <div className="absolute inset-0 opacity-20 ethiopian-cross" />
        <div className="relative max-w-7xl mx-auto px-4 sm:px-6">
          <motion.div initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} className="max-w-3xl">
            <h1 className="font-serif-elegant text-4xl sm:text-5xl font-bold text-white mb-4">
              {t("events.title")}
            </h1>
            <p className="text-white/80 text-lg">{t("events.intro")}</p>
          </motion.div>
        </div>
      </section>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 py-12">
        <div className="grid lg:grid-cols-[0.75fr_1.25fr] gap-8 mb-10">
          <div className="bg-white rounded-3xl p-8 border border-[#C9A227]/10 shadow-sm">
            <h2 className="font-serif-elegant text-2xl font-bold text-[#722F37] mb-6">
              {t("events.rhythmTitle")}
            </h2>
            <div className="space-y-4">
              {schedule.map((item) => (
                <div key={item.title} className="rounded-2xl bg-[#f7f1e8] p-4">
                  <p className="text-sm font-semibold text-[#722F37]">{item.title}</p>
                  <p className="text-sm text-[#C9A227] mt-1">{item.time}</p>
                  <p className="text-sm text-gray-600 mt-2">{item.detail}</p>
                </div>
              ))}
            </div>
          </div>

          <div className="grid md:grid-cols-2 gap-6">
            {events.map((event) => (
              <motion.div
                key={`${event.title}-${event.dateLabel}`}
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                className="bg-white rounded-3xl shadow-sm p-6 border border-[#C9A227]/10 flex flex-col gap-4"
              >
                <div className="flex items-start justify-between gap-3">
                  <div>
                    <h2 className="font-serif-elegant text-xl font-bold text-[#722F37] mb-1">
                      {event.title}
                    </h2>
                    <p className="text-sm text-gray-500">{event.category}</p>
                  </div>
                  {event.featured && (
                    <span className="inline-flex items-center gap-1 px-2 py-1 rounded-full bg-[#C9A227]/10 text-[#C9A227] text-xs font-medium">
                      <Star className="w-3 h-3" />
                      {t("events.featured")}
                    </span>
                  )}
                </div>

                <p className="text-sm text-gray-600">{event.description}</p>

                <div className="mt-auto space-y-1 text-sm text-gray-700">
                  <div className="flex items-center gap-2">
                    <Calendar className="w-4 h-4 text-[#C9A227]" />
                    <span>{event.dateLabel}</span>
                    {event.time && <span>• {event.time}</span>}
                  </div>
                  {event.location && (
                    <div className="flex items-center gap-2">
                      <MapPin className="w-4 h-4 text-[#C9A227]" />
                      <span>{event.location}</span>
                    </div>
                  )}
                </div>
              </motion.div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}
